module.exports = __webpack_public_path__ + "static/behzisti-7bd9ba0f07a166df3692b92989583b4d.png";